import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatChipListbox } from '@angular/material/chips';
import { IParametric } from 'src/app/shared/interfaces/parametric.interface';
export interface Fruit {
  name: string;
  selected: boolean;
}

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnChanges {

  
  @Input() superGroup:IParametric={code:"",description:"",thematics:[]};
  @Output() returnData:EventEmitter<IParametric>= new EventEmitter<IParametric>();

  @ViewChild('chipList')
  chipList!: MatChipListbox;
  selected:boolean=false;
  
  ngOnChanges(changes: SimpleChanges): void {
    var countThematics=this.superGroup.thematics.filter(x=>x.selected==false).length;
    if(countThematics==0){
      this.selected=true;
    }else{
      this.selected=false;
    }
  }

  clickSuperGroup(){
    this.selected=!this.selected;
    if(this.selected){
      this.superGroup.thematics.map(x=>x.selected=true);
    }else{
      this.superGroup.thematics.map(x=>x.selected=false);
    }
    this.returnData.emit(this.superGroup); 
  }
  clickThematic(obj:any){
    obj.selected=!obj.selected;
    var countThematics=this.superGroup.thematics.filter(x=>x.selected==false).length;
    if(countThematics==0){
      this.selected=true;
    }else{
      this.selected=false;
    }
    this.returnData.emit(this.superGroup); 
  }
}
